import React from "react"
import styled from "styled-components"

const Contact = () => {
  return (
    <Container>
      <Heading id="contact">Contact</Heading>
      <Description>
        Please fill out the form below for all pricing inquiries. Include as
        much detail about the project as possible, such as the timeframe and
        location of the project, the number of images needed, and what the
        images will be used for. I look forward to the opportunity of working
        with you.
      </Description>
      <Form>
        <div className="name-container">
          <input
            className="contact-info name"
            type="text"
            placeholder="First Name"
          />
          <input
            className="contact-info name"
            type="text"
            placeholder="Last Name"
          />
        </div>
        <input className="contact-info" type="email" placeholder="Email" />
        <textarea placeholder="Enter your message here..." />
        <input type="button" value="Send" />
      </Form>
      <Map>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3330.254619076849!2d-111.9364296846456!3d33.41660555840486!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x872b08c354f63449%3A0xf3f3495da6a199df!2sW.%20P.%20Carey%20School%20of%20Business%20-%20Arizona%20State%20University!5e0!3m2!1sen!2sus!4v1588536399645!5m2!1sen!2sus"
          width="100%"
          height="100%"
          frameBorder="0"
        />
      </Map>
    </Container>
  )
}

export default Contact

const Container = styled.div`
  font-family: "lato";
  margin: 0 2.5px;

  @media screen and (min-width: 1000px) {
    margin-left: 25vw;
  }

  @media screen and (min-width: 1400px) {
    margin-left: 350px;
  }
`

const Heading = styled.h1`
  font-family: "julius sans one";
  font-size: clamp(1.5rem, 5vw, 2rem);
  /* margin-top: 2vh; */
  padding-top: 5.5vh;
`

const Description = styled.p`
  font-size: clamp(1rem, 1.5vw, 1.1rem);
  margin-right: 2.5px;
  max-width: 800px;
  margin-top: 1vh;
  line-height: 1.5rem;
`

const Form = styled.form`
  max-width: 800px;

  .contact-info {
    display: block;
    width: 100%;
    padding: 10px;
    margin: 2vh 0;
    /* margin-top: 7px; */
    border: none;
    border-bottom: 2px solid #ccc;
    transition: 0.5s;
    outline: none;

    &:focus {
      border-bottom: 2px solid #555;
    }
  }

  .name-container {
    @media screen and (min-width: 800px) {
      display: flex;
      justify-content: space-between;
    }
  }

  .name {
    @media screen and (min-width: 800px) {
      max-width: 380px;
    }
  }

  textarea {
    width: 100%;
    height: 200px;
    padding: 10px;
    margin-top: 7px;
    font-family: "lato";
    border: 2px solid #ccc;
    transition: 0.5s;
    resize: none;
    outline: none;

    &:focus {
      border: 2px solid #555;
    }
  }

  input[type="button"] {
    font-family: "lato";
    width: 100%;
    margin-top: 5px;
    padding: 8px;
    background: none;
    border: 2px solid #ccc;
    cursor: pointer;
    transition: 0.5s;

    &:hover {
      border: 2px solid #555;
    }
  }
`

const Map = styled.div`
  margin-top: 15px;
  max-width: 800px;
  height: 300px;
`
